.BlockFilters {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  flex-shrink: 0;
  border-radius: 30px;
  background: var(--overlay);
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
}

.BlockFiltersClosed{
  width: 20px;
}

.ButtonToggleFilters{
  width: 31px;
  height: 31px;
  border-radius: 10px;
  background: var(--colori-neutri-gray-2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--primary);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  position: relative;
}

.TopFiltri {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  border-bottom: 0.5px solid var(--primary);
  padding-bottom: 4px;
}

.FilterLabel {
  color: var(--primary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 8px;
  padding-bottom: 5px;
}

.FilterLabelFiltri {
  color: var(--primary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 8px;
}

.ResetButton {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: rgba(17, 138, 178, 0.8);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--colori-neutri-white);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  margin-right: 8px;
}

.ResetButtonDisabled {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  border: none;
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--colori-neutri-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: not-allowed;
  margin-right: 8px;
}

.Badge{
  position: absolute;
  top: -3px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--tertiary);
}

.FilterLabel {
  color: var(--primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.FilterComune {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 18px;
  /* border-bottom: 1px solid var(--colori-neutri-white); */
}

.InputComune {
  display: flex;
  padding: 8px 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  align-self: stretch;
  border-radius: 30px;
  border: 1px solid var(--secondary-variant);
  background: var(--colori-neutri-white);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--secondary);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.SelectCategoria {
  display: flex;
  padding: 8px 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  align-self: stretch;
  border-radius: 30px;
  border: 1px solid var(--secondary-variant);
  background: var(--colori-neutri-white);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--secondary);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 36px;
  cursor: pointer;
  position: relative;
}

.OptionsCategoria{
  /* uguale a comuni list */
  display: flex;
  max-height: 200px;
  padding: 8px;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  gap: 4px;
  align-self: stretch;
  border-radius: 10px;
  margin-top: 8px;
}

.InputCategoria {
  display: flex;
  padding: 8px 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  align-self: stretch;
  border-radius: 30px;
  border: 1px solid var(--secondary-variant);
  background: var(--colori-neutri-white);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--secondary);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.InputComune:focus-visible {
  outline: none;
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
}

.InputComune::placeholder {
  color: var(--colori-neutri-gray-2);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.SelectCategoriaPlaceholder{
  color: var(--colori-neutri-gray-2);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.FilterCategoria {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 8px;
  margin-top: 18px;
}

.FilterOptions {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
}

.FilterItem {
  display: flex;
  height: 34px;
  padding: 8px 0px 8px 24px;
  cursor: pointer;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  color: var(--primary);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 100%;
  line-height: normal;
}

.FilterItemTitle {
  display: flex;
  align-items: center;
}

.FilterItemActive {
  background: var(--primary);
  width: 100%;
  color: var(--colori-neutri-white);
}

.FilterTitle {
  color: var(--primary);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.SelectCategoria {
  width: 100%;
}

.Filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 18px;
  /* border-bottom: 1px solid var(--colori-neutri-white); */
}

.ComuniList {
  display: flex;
  max-height: 254px;
  padding: 8px;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  gap: 4px;
  align-self: stretch;
  border-radius: 10px;
  margin-top: 8px;
  background: var(--colori-neutri-gray-2);
}

.NoResults{
  background: var(--colori-neutri-gray-2);
  color: var(--colori-neutri-gray);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 8px 24px;
  border-radius: 10px;
  margin-top: 8px;
  width: 100%;
}

.ComuneItem {
  display: flex;
  height: 43px;
  padding: 8px 24px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 5px;
  border: 0.5px solid var(--overlay);
  background: var(--colori-neutri-white);
  color: var(--primary);
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.ComuneItemTitle {
  display: flex;
  align-items: center;
}

.SelectCategoriaText{
  display: flex;
  align-items: center;
}

.ExpandIcon{
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.CloseIconWrapper {
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.PointComune {
  position: absolute;
  right: 65px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
